import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { CompletionRequirementContent } from "./CompletionRequirementContent"
import { CloseButton } from "../../../../components/closeButton/CloseButton"
import SlideUpModal from "../../../../components/slideUpModal/SlideUpModal"

export interface CompletionRequirementModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useCompletionRequirementModalStore =
  create<CompletionRequirementModalStore>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))

export const CompletionRequirementModal = () => {
  const { isOpen, onClose } = useCompletionRequirementModalStore()
  const { t } = useTranslation()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      zIndex={1000}
    >
      <FlexBox
        direction="column"
        align="center"
        wrap={false}
        fullWidth
        gap={SPACING.space4}
        style={{
          position: "relative",
          background: JoonUIColor.background.xlightGray,
          paddingTop: SPACING.space4,
          paddingBottom: SPACING.space8,
          padding: SPACING.space4,
        }}
      >
        <CloseButton onClick={onClose} />
        <Typography variant="bodyBold" textAlign="left">
          {t("QUEST_ADD_COMPLETION_REQ")}
        </Typography>
        <CompletionRequirementContent />
      </FlexBox>
    </SlideUpModal>
  )
}
